import i18next from 'i18next'
import { utils } from 'frontend-js-shared'
import constants from '@/constants'

const PREDEFINED_DATE_RANGES = utils.dates.PREDEFINED_DATE_RANGES

export default {
  roleOptions: [
    {
      value: constants.exploreRoleTypes.owner,
      text: i18next.t('common.roles.i_am_owner'),
    },
    {
      value: constants.exploreRoleTypes.coach,
      text: i18next.t('common.roles.i_am_coach'),
    },
    {
      value: constants.exploreRoleTypes.collaborators,
      text: i18next.t('common.roles.i_am_collaborator'),
    },
  ],

  priorityOptions: [
    {
      value: constants.priorities.high,
      text: i18next.t('rev.priority.high'),
    },
    {
      value: constants.priorities.medium,
      text: i18next.t('rev.priority.medium'),
    },
    {
      value: constants.priorities.low,
      text: i18next.t('rev.priority.low'),
    },
  ],

  validationOptions: [
    {
      text: i18next.t('rev.validation.not_implemented'),
      value: 'hasNotImplementationValidation',
    },
    {
      text: i18next.t('rev.validation.implemented'),
      value: 'hasImplementationValidation',
    },
    {
      text: i18next.t('rev.validation.impact_validated'),
      value: 'hasFinancialValidation',
    },
  ],

  commonDateOptions: [
    {
      value: PREDEFINED_DATE_RANGES.today,
      text: i18next.t('explore.filters.today'),
    },
    {
      value: PREDEFINED_DATE_RANGES.thisMonth,
      text: i18next.t('explore.filters.this_month'),
    },
    {
      value: PREDEFINED_DATE_RANGES.thisYear,
      text: i18next.t('explore.filters.this_year'),
    },
    {
      value: PREDEFINED_DATE_RANGES.lastMonth,
      text: i18next.t('explore.filters.last_month'),
    },
    {
      value: PREDEFINED_DATE_RANGES.last7Days,
      text: i18next.t('explore.filters.last_7_days'),
    },
    {
      value: PREDEFINED_DATE_RANGES.last30Days,
      text: i18next.t('explore.filters.last_30_days'),
    },
    {
      value: PREDEFINED_DATE_RANGES.last90Days,
      text: i18next.t('explore.filters.last_90_days'),
    },
    {
      value: PREDEFINED_DATE_RANGES.lastQuarter,
      text: i18next.t('explore.filters.last_quarter'),
    },
    {
      value: constants.DATE_FILTER_OPTIONS.custom,
      text: i18next.t('explore.filters.custom'),
    },
  ],

  dueDateOptions: [
    {
      value: PREDEFINED_DATE_RANGES.thisWeek,
      text: i18next.t('explore.filters.this_week'),
    },
    {
      value: PREDEFINED_DATE_RANGES.nextWeek,
      text: i18next.t('explore.filters.next_week'),
    },
    {
      value: constants.DATE_FILTER_OPTIONS.custom,
      text: i18next.t('explore.filters.custom'),
    },
  ],

  filtersKeys: {
    sites: 'sites',
    types: 'types',
    status: 'status',
    role: 'role',
    priority: 'priority',
    condition: 'condition',
    approval: 'approval',
    validation: 'validation',
    siteGroups: 'siteGroups',
    countryCodes: 'countryCodes',
    tags: 'tags',
    tagGroups: 'tagGroups',
    categories: 'categories',
    assignees: 'assignees',
    createdAtOption: 'createdAtOption',
    dueDateOption: 'dueDateOption',
    completedAtOption: 'completedAtOption',
    routineDefinitions: 'routineDefinitions',
    routineType: 'routineType',
    activeRoutine: 'activeRoutine',
    situationTypes: 'situationTypes',
    createdBy: 'createdBy',
  },

  dateFilters: {
    dueDateOption: 'dueDate',
    createdAtOption: 'createdAt',
    completedAtOption: 'completedAt',
  },

  validationFilters: {
    implemented: 'hasImplementationValidation',
    notImplemented: 'hasNotImplementationValidation',
    validated: 'hasFinancialValidation',
  },

  conditionFilters: {
    highlighted: 'isHighlighted',
    hasPlannerIntegration: 'hasPlannerIntegration',
    isReplica: 'isReplica',
    hasReplicas: 'hasReplicas',
    isRevFromFinding: 'isRevFromFinding',
    isNotRevFromFinding: 'isNotRevFromFinding',
  },

  approvalFilters: {
    approved: 'isApproved',
    requested: 'isApprovalRequested',
    waitingForMyApproval: 'waitingForMyApproval',
    rejected: 'isRejected',
  },

  roleFilters: {
    owner: 'owner',
    coach: 'coach',
    collaborator: 'collaborators',
  },

  routineType: [
    {
      value: '5s_audit',
      text: i18next.t('routines.type.5s_audit'),
    },
    {
      value: 'maintenance',
      text: i18next.t('routines.type.maintenance'),
    },
    {
      value: 'gemba',
      text: i18next.t('routines.type.gemba'),
    },
    {
      value: 'quality_control',
      text: i18next.t('routines.type.quality_control'),
    },
    {
      value: 'communication',
      text: i18next.t('routines.type.communication'),
    },
    {
      value: 'financial_tracking',
      text: i18next.t('routines.type.financial_tracking'),
    },
  ],

  activeRoutine: [
    {
      value: 'active',
      text: i18next.t('common.active'),
    },
    {
      value: 'inactive',
      text: i18next.t('common.inactive'),
    },
  ],
}
